import { render } from "./DigitalClock.vue?vue&type=template&id=0fa1a6b6&scoped=true"
import script from "./DigitalClock.vue?vue&type=script&lang=js"
export * from "./DigitalClock.vue?vue&type=script&lang=js"

import "./DigitalClock.vue?vue&type=style&index=0&id=0fa1a6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa1a6b6"]])

export default __exports__